var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-upload-container",
      style: { width: _vm.containerWidth }
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "align-center": "" } },
        [
          _c(
            "v-flex",
            { class: { xs8: _vm.selectedImage, xs12: !_vm.selectedImage } },
            [
              _c(
                "v-autocomplete",
                {
                  attrs: {
                    items: _vm.imageOptions,
                    label: _vm.label,
                    placeholder: _vm.placeholder,
                    "item-text": "name",
                    "item-value": "downloadURL",
                    clearable: "",
                    loading: _vm.loading || _vm.isUploading,
                    disabled: _vm.disabled,
                    "return-object": "",
                    "hide-details": "",
                    rules: _vm.rules
                  },
                  on: {
                    change: _vm.handleSelectionChange,
                    "click:clear": _vm.handleClear
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "selection",
                      fn: function(data) {
                        return [
                          data.item
                            ? _c(
                                "v-chip",
                                { staticClass: "ma-1" },
                                [
                                  _c("v-avatar", { attrs: { left: "" } }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          data.item.thumbnail ||
                                          data.item.base64,
                                        alt: data.item.name
                                      }
                                    })
                                  ]),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(data.item.name) +
                                      "\n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "item",
                      fn: function(data) {
                        return [
                          typeof data.item !== "object"
                            ? [
                                _c("v-list-tile-content", {
                                  domProps: { textContent: _vm._s(data.item) }
                                })
                              ]
                            : [
                                _c("v-list-tile-avatar", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        data.item.thumbnail || data.item.base64,
                                      alt: data.item.name
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", {
                                      domProps: {
                                        innerHTML: _vm._s(data.item.name)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-list-tile-sub-title", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatFileSize(data.item.size)
                                        )
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-action",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "remove-btn",
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          loading:
                                            _vm.deletingItemId === data.item.id,
                                          disabled: _vm.disabled
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleRemoveItem(
                                              data.item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { small: "", color: "error" }
                                          },
                                          [_vm._v("delete")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedImage,
                    callback: function($$v) {
                      _vm.selectedImage = $$v
                    },
                    expression: "selectedImage"
                  }
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "append-outer" },
                    [
                      _c("UploadFileWidget", {
                        ref: "uploadWidget",
                        attrs: {
                          type: "letterheads",
                          acceptTypes: _vm.acceptedTypes,
                          sizeLimit: _vm.maxFileSize,
                          small: true,
                          icon: true,
                          iconType: "add_photo_alternate",
                          disabled: _vm.disabled
                        },
                        on: {
                          getUploadingFileData: _vm.handleFileUpload,
                          error: _vm.handleUploadError,
                          filesStatus: _vm.handleFilesStatus
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.selectedImage
            ? _c(
                "v-flex",
                { staticClass: "pl-2", attrs: { xs4: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "view-btn",
                      attrs: {
                        color: "primary",
                        outline: "",
                        block: "",
                        small: "",
                        disabled: _vm.disabled
                      },
                      on: {
                        click: function($event) {
                          _vm.showImageDialog = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("visibility")
                      ]),
                      _vm._v("\n        " + _vm._s(_vm.$t("view")) + "\n      ")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition",
            "content-class": "image-preview-dialog"
          },
          model: {
            value: _vm.showImageDialog,
            callback: function($$v) {
              _vm.showImageDialog = $$v
            },
            expression: "showImageDialog"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "image-overlay",
              on: {
                click: function($event) {
                  _vm.showImageDialog = false
                }
              }
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "image-container",
                  attrs: {
                    column: "",
                    "align-center": "",
                    "justify-center": ""
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c(
                    "v-flex",
                    { staticClass: "image-toolbar", attrs: { xs12: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-3",
                          attrs: { color: "rgba(0,0,0,0.7)" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { "align-center": "" } },
                            [
                              _c("v-flex", { staticClass: "white--text" }, [
                                _c("h3", { staticClass: "ma-0" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedImage
                                        ? _vm.selectedImage.name
                                        : ""
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: { icon: "", dark: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.showImageDialog = false
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white", large: "" } },
                                    [_vm._v("close")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "image-content", attrs: { xs12: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "image-wrapper" },
                        [
                          _vm.selectedImage
                            ? _c("img", {
                                staticClass: "preview-image",
                                attrs: {
                                  src:
                                    _vm.selectedImage.base64 ||
                                    _vm.selectedImage.thumbnail,
                                  alt: _vm.selectedImage.name
                                }
                              })
                            : _c(
                                "v-layout",
                                {
                                  attrs: {
                                    "fill-height": "",
                                    "align-center": "",
                                    "justify-center": ""
                                  }
                                },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "white",
                                      size: "70"
                                    }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "image-footer", attrs: { xs12: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-3",
                          attrs: { color: "rgba(0,0,0,0.7)" }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                "align-center": "",
                                "justify-space-between": ""
                              }
                            },
                            [
                              _c("v-flex", { staticClass: "white--text" }, [
                                _c("div", [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("fileSize")) + ":")
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selectedImage
                                          ? _vm.formatFileSize(
                                              _vm.selectedImage.size
                                            )
                                          : ""
                                      ) +
                                      " |\n                    "
                                  ),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("fileType")) + ":")
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selectedImage
                                          ? _vm.selectedImage.type
                                          : ""
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.selectedImage && _vm.selectedImage.createdAt
                                  ? _c("div", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.$t("uploadTime")) + ":"
                                        )
                                      ]),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            new Date(
                                              _vm.selectedImage.createdAt.toDate
                                                ? _vm.selectedImage.createdAt.toDate()
                                                : _vm.selectedImage.createdAt
                                            ).toLocaleString()
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df1b66d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df1b66d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ETDSelector.vue
// module id = null
// module chunks = 